export const FILE_STAGE = {
    registered: { token: 'info', icon: 'document-plus', en: 'Registered', ne: 'दर्ता भयो' },
    assigned: { token: 'info', icon: 'user-check', en: 'Assigned', ne: 'जिम्मा दिइयो' },
    underReview: { token: 'info', icon: 'eye', en: 'Under review', ne: 'समीक्षामा' },
    forwarded: { token: 'info', icon: 'arrow-right', en: 'Forwarded', ne: 'पठाइयो' },
    approved: { token: 'good', icon: 'check-circle', en: 'Approved', ne: 'स्वीकृत' },
    rejected: { token: 'critical', icon: 'x-circle', en: 'Rejected', ne: 'अस्वीकृत' },
    completed: { token: 'good', icon: 'check-circle-double', en: 'Completed', ne: 'सम्पन्न' },
    archived: { token: 'neutral', icon: 'archive-box', en: 'Archived', ne: 'अभिलेखीकरण गरियो' },
};
/** Orthogonal flag, appended to any stage above — never a stage of its own. */
export const OVERDUE_FLAG = {
    token: 'serious',
    icon: 'alert-triangle',
    en: 'Overdue',
    ne: 'म्याद नाघेको',
};
export const APPOINTMENT_STATUS = {
    pending: { token: 'info', icon: 'clock', en: 'Pending', ne: 'विचाराधीन' },
    accepted: { token: 'good', icon: 'check-circle', en: 'Accepted', ne: 'स्वीकृत' },
    rescheduled: { token: 'warning', icon: 'calendar-clock', en: 'Rescheduled', ne: 'पुनः तालिका' },
    declined: { token: 'critical', icon: 'x-circle', en: 'Declined', ne: 'अस्वीकार गरियो' },
    completed: { token: 'good', icon: 'check-circle-double', en: 'Completed', ne: 'सम्पन्न' },
    expired: { token: 'neutral', icon: 'clock-x', en: 'Expired', ne: 'म्याद सकियो' },
};
/** Public-safe, coarse only — never location/GPS (§9.3). */
export const OFFICER_AVAILABILITY = {
    available: { token: 'good', icon: 'circle-check', en: 'Available', ne: 'उपलब्ध' },
    busy: { token: 'warning', icon: 'circle-minus', en: 'Busy', ne: 'व्यस्त' },
    inMeeting: { token: 'warning', icon: 'users', en: 'In a meeting', ne: 'बैठकमा' },
    onLeave: { token: 'neutral', icon: 'calendar-x', en: 'On leave', ne: 'बिदामा' },
    outOfOffice: { token: 'neutral', icon: 'door', en: 'Out of office', ne: 'कार्यालय बाहिर' },
};
//# sourceMappingURL=lifecycle-labels.js.map